import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { KeysPipe } from '../../../shared/filters/keyvalue.pipe';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import dataToyota_footer from '../../../../assets/data/toyota/footerResources.json';
import dataLexus_footer from '../../../../assets/data/lexus/footerResources.json';

@Component({
  selector: 'app-footer-resources',
  templateUrl: './footer-resources.component.html',
  styleUrls: ['./footer-resources.component.scss']
})
export class FooterResourcesComponent implements OnInit {

  public appName = '';
  public logoPath = '';
  public mockData = {};
  public resources = {};
  // public data_footer = {};
  public isInternal = false;

  constructor(
    public commonService: TCCPCommonService, private router: Router, private storageService: TCCPLocalStorageService) { }

  ngOnInit() {
    this.isInternal = false;
    this.appName = environment.applicationName;
    if (this.appName === 'toyota') {
      this.mockData = dataToyota_footer;
    } else {
      this.mockData = dataLexus_footer;
    }
    this.resources = this.mockData['resources'];
    this.isInternal = this.commonService.setAppFeatureType(this.router.url);
  }

  public onLogoClick() {
    this.storageService.clearStorage();
  }

  openFileInNewTab(e, url) {
    if (e) {
      e.preventDefault();
    }
    if (url) {
      window.open(url, '_blank');
    }
  }

}